import { Component, Injector, Input, OnInit, signal } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { finalize } from 'rxjs';
import { Business } from '../../models/finance/business';
import { BusinessProxyService } from '../../proxies/finance/business.proxy.service';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';

@Component({
  selector: 'app-business-lot-numbers-modal',
  templateUrl: './business-lot-numbers-modal.component.html',
  styleUrl: './business-lot-numbers-modal.component.scss',
})
export class BusinessLotNumbersModalComponent extends BaseModalComponent<Business | null> implements OnInit {
  @Input() business!: Business;

  isSaving = signal<boolean>(false);
  editableLotNumbers = signal<string[]>([]);
  newLotNumber = signal<string>('');

  constructor(
    injector: Injector,
    private businessProxyService: BusinessProxyService,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.editableLotNumbers.set([...(this.business.lotNumbers ?? [])]);
  }

  addLotNumber(): void {
    const value = this.newLotNumber().trim();
    if (!value) return;
    if (this.editableLotNumbers().includes(value)) {
      GlobalMessageUtil.error('Duplicate', 'Lot number already exists');
      return;
    }
    this.editableLotNumbers.set([...this.editableLotNumbers(), value]);
    this.newLotNumber.set('');
  }

  removeLotNumber(lotNumber: string): void {
    this.editableLotNumbers.set(this.editableLotNumbers().filter((l) => l !== lotNumber));
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') this.addLotNumber();
  }

  onSave(): void {
    if (!this.business.id) return;
    this.isSaving.set(true);

    this.businessProxyService
      .setLotNumbers(this.business.id, this.editableLotNumbers())
      .pipe(finalize(() => this.isSaving.set(false)))
      .subscribe({
        next: () => {
          GlobalMessageUtil.success('Success', 'Lot numbers updated');
          this.close({ action: 'save', data: { ...this.business, lotNumbers: [...this.editableLotNumbers()] } });
        },
      });
  }

  onClose(): void {
    this.close({ action: 'close', data: null });
  }
}
